// AUTH & Tokens
export const PERSISTENCE_KEY_REFRESH_TOKEN_CODE = 'auth_refresh_token';
export const PERSISTENCE_KEY_TOKEN_EXPIRES_CODE = 'auth_expires';
export const PERSISTENCE_KEY_TOKEN_EXPIRES_AT_CODE = 'auth_expires_at';
export const PERSISTENCE_KEY_REFRESH_TOKENS_LOCK_CODE =
  'auth_refresh_token_lock';
export const PERSISTENCE_KEY_AUTH_ACTIVE_TABS_CODE = 'auth_active_tabs';
export const PERSISTENCE_KEY_AUTH_MAIN_TAB_CODE = 'auth_main_tab';
export const AUTH_TOKEN = 'auth_token';
